import React, { Component, Fragment } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { parse } from 'helpers/query-string';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
import Settings from '@material-ui/icons/Settings';
import AddAlert from '@material-ui/icons/AddAlert';

// core components
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import Button from 'components/CustomButtons/Button';
import Snackbar from 'components/Snackbar/Snackbar';
import ImageUpload from 'components/CustomUpload/ImageUpload';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';

// others
import config from 'config';
import { Context } from 'context/Context';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';
import FormHOC from 'hoc/FormHOC';

class ChangeDiary extends Component {
  state = {
    user: null,
  };

  componentDidMount() {
    const search = parse(this.props.location.search, '&', '=');
    const token = search['token'];
    token
      ? axios
          .post(`${config.API_URL}/public/auth/verify_token`, {
            token,
          })
          .then(({ data: { user } }) => {
            if (user.account.type !== 'student') {
              this.props.history.push('/');
            }
            this.setState((prevState) => ({ ...prevState, user }));
          })
          .catch(() => {
            this.props.history.push('/');
          })
      : this.props.history.push('/');
  }

  componentWillUnmount() {
    this.props.context.closeSnackbar();
  }

  updateUser = () => {
    const { updateUser, handleSnackbar } = this.props.context;
    const { user } = this.state;
    const account = user.account;
    const { diary, handleRemoveImage } = this.props;

    const body = {
      'account.diary_picture': diary,
      'account.diary_changed_at': new Date(),
    };

    const _id = user._id;
    axios
      .put(`${config.API_URL}/api/users/${_id}`, body, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      })
      .then((res) => {
        // remove picture if difference
        if (account.diary && account.diary !== diary) {
          handleRemoveImage('diary');
        }

        updateUser(res.data.user);

        handleSnackbar({
          status: 'success',
          message: res.data.message,
        });
      })
      .catch((e) => {
        const message =
          e.response && e.response.data.error.code === 11000
            ? 'Un utilisateur avec cet email existe déjà'
            : 'Oups.. Un problème est survenu';

        handleSnackbar({
          status: 'danger',
          message,
        });
      });
  };

  render() {
    const { classes, diaryLoading, diaryState, handleChangeImage, handleRemoveImage } = this.props;

    const {
      closeSnackbar,
      state: { snackbar },
    } = this.props.context;

    const diaryTitle = cx({
      [classes.text]: true,
      [classes.dangerColor]: diaryState === 'error',
      [classes.successColor]: diaryState === 'success',
    });

    const borderButtonDiary = cx({
      [classes.borderButton]: true,
      [classes.noBorderButton]: diaryLoading,
    });

    const content = (
      <form className={classes.formContainer}>
        <GridContainer justifyContent='center'>
          <ItemGrid xs={12} sm={4} className={classes.flexCenter}>
            <div className={classes.containerUpload}>
              <p className={diaryTitle}>Prenez en photo votre carnet de correspondance</p>
              <ImageUpload
                success={diaryState === 'success'}
                error={diaryState === 'error'}
                color='white'
                customClass={borderButtonDiary}
                labelText='Carnet de correspondance'
                loading={diaryLoading}
                handleChange={(event) => handleChangeImage(event, 'diary')}
                handleRemove={() => handleRemoveImage('diary')}
              />
              <div className={classes.helpTextButton}>
                <Button customClass={classes.seeExampleButton} onClick={this.toggleModal}>
                  Voir un exemple
                </Button>{' '}
                -<small> obligatoire</small>
              </div>
            </div>
          </ItemGrid>
        </GridContainer>
      </form>
    );

    const footer = (
      <Fragment>
        <Button color='primary' onClick={this.updateUser} customClass={classes.footerButton}>
          Valider
        </Button>
      </Fragment>
    );

    const snackbarContainer = snackbar && snackbar.isSnackbar && (
      <Snackbar
        key='snackbar'
        place='tr'
        color={snackbar.status}
        icon={AddAlert}
        message={snackbar.message}
        open={true}
        closeNotification={closeSnackbar}
        close
      />
    );

    return (
      <ErrorBoundaries>
        <div>
          {snackbarContainer}
          <GridContainer justifyContent='center' alignItems='center' style={{ zIndex: 3, height: '100vh' }}>
            <ItemGrid xs={12} style={{ zIndex: 3 }}>
              <IconCard
                icon={Settings}
                title='Formulaire de modification de carnet de correspondance'
                iconColor='pink'
                footerAlign='center'
                footer={footer}
                content={content}
              />
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

ChangeDiary.propTypes = {
  context: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const WrappedComponent = FormHOC(ChangeDiary);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
